import { Box, Inline, xcss } from '@atlaskit/primitives';
import DatabasePicker from '@databases/content-picker/DatabasePicker';
import {
  type BrokenDatabase,
  type Database,
  type DatabaseField,
  type EntryCreateOptions,
  type EntryWithContext,
} from '@databases/types/database';
import React, { type FunctionComponent, useCallback } from 'react';

import DatabaseEntryPicker from '../entryPicker/DatabaseEntryPicker';
import DatabaseValuePicker from '../valuePicker/DatabaseValuePicker';

const pickerStyles = xcss({
  width: '240px',
});

export interface EmbedReferencePickerProps {
  databaseError: boolean;
  selectedDatabase: Database | BrokenDatabase | undefined;
  selectedEntry: EntryWithContext | EntryCreateOptions | undefined;
  selectedField: DatabaseField | undefined;
  setSelectedDatabase: (value: Database | BrokenDatabase | undefined) => void;
  setSelectedEntry: (value: EntryWithContext | EntryCreateOptions | undefined) => void;
  setSelectedField: (value: DatabaseField | undefined) => void;
  isEmptySubmit: boolean;
  setIsEmptySubmit: (isEmptySubmit: boolean) => void;
}

const EmbedReferencePicker: FunctionComponent<EmbedReferencePickerProps> = ({
  databaseError,
  selectedDatabase,
  selectedEntry,
  selectedField,
  setSelectedDatabase,
  setSelectedEntry,
  setSelectedField,
  isEmptySubmit,
  setIsEmptySubmit,
}) => {
  const onDatabaseChange = useCallback(
    (val: Database | BrokenDatabase | undefined) => {
      if (val) {
        setSelectedDatabase(val);
        setIsEmptySubmit(false);
      } else {
        setSelectedDatabase(undefined);
        setIsEmptySubmit(true);
      }

      setSelectedEntry(undefined);
      setSelectedField(undefined);
    },
    [setIsEmptySubmit, setSelectedDatabase, setSelectedEntry, setSelectedField]
  );

  return (
    <Inline
      xcss={xcss({
        gap: 'space.150',
      })}
      alignInline="start"
    >
      <Box xcss={pickerStyles}>
        <DatabasePicker
          onChange={onDatabaseChange}
          selectedDatabase={selectedDatabase}
          isInvalid={databaseError || isEmptySubmit}
        />
      </Box>

      <Box xcss={pickerStyles}>
        <DatabaseEntryPicker
          selectedDatabase={selectedDatabase}
          setSelectedEntry={setSelectedEntry}
          selectedEntry={selectedEntry}
          setSelectedField={setSelectedField}
          canCreate={selectedDatabase ? selectedDatabase.operations.updateEntries : false}
        />
      </Box>

      <Box xcss={pickerStyles}>
        <DatabaseValuePicker
          selectedDatabase={selectedDatabase}
          selectedEntry={selectedEntry}
          selectedField={selectedField}
          setSelectedField={setSelectedField}
        />
      </Box>
    </Inline>
  );
};
export default EmbedReferencePicker;
